export const SUPPORT_PATH = '/support';

export default [
	{
		path: SUPPORT_PATH,
		lazy: async () => {
			const Module = await import('../../pages/Support');
			return { Component: Module.default };
		},
	},
	{
		path: `${SUPPORT_PATH}/:id`,
		lazy: async () => {
			const Module = await import('../../pages/Support/ClientRequestPage');
			return { Component: Module.default };
		},
	},
];
